import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";

export default function RefRedirect() {
  const { slug } = useParams();
  useEffect(() => {
    if (slug) {
      localStorage.setItem("gs_ref_code", slug);
      api.post("/affiliate/click", { ref: slug }).catch(() => {});
    }
    const t = setTimeout(() => { window.location.replace("/"); }, 400);
    return () => clearTimeout(t);
  }, [slug]);
  return (
    <div className="min-h-screen bg-background flex items-center justify-center text-muted-foreground">
      Taking you to AutoGridSocial…
    </div>
  );
}
